import axios from "axios";
import { COST_SUMMARY_FAIL, COST_SUMMARY_REQUEST, COST_SUMMARY_RESET, COST_SUMMARY_SUCCESS } from "../../constants/ConstSummaryConstants";
import { API_URI } from "../../constants/GlobalConstants";

export const fetchCostSummary = (start, end, productType) => async (dispatch, getState) => {
  try {
    dispatch({ type: COST_SUMMARY_REQUEST });

    const {
      userSignIn: { userInfo },
    } = getState();

    const response = await axios.get(`${API_URI}/api/order/cost-summary`, {
      headers: { Authorization: `Bearer ${userInfo.token}` },
      params: {
        startDate: start,
        endDate: end,
        productType,
      },
    });

    dispatch({
      type: COST_SUMMARY_SUCCESS,
      payload: response.data.data,
    });
  } catch (error) {
    dispatch({
      type: COST_SUMMARY_FAIL,
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const resetCostSummary = () => (dispatch) => {
  dispatch({ type: COST_SUMMARY_RESET });
};

export const fetchCostAndInventoryUtilization = (start, end, productType, token) => async (dispatch) => {
  try {
    dispatch({ type: 'ANAL_COST_INVENTORY_REQUEST' });
    const { data } = await axios.get(`${API_URI}/api/analytics/cost-inventory-utilization`, {
      headers: { Authorization: `Bearer ${token}` },
      params: { startDate: start, endDate: end, productType },
    });
    dispatch({ type: 'ANAL_COST_INVENTORY_SUCCESS', payload: data.data });
  } catch (error) {
    dispatch({
      type: 'ANAL_COST_INVENTORY_FAIL',
      payload: error.response && error.response.data.message ? error.response.data.message : error.message,
    });
  }
};

export const resetCostAndInventoryUtilization = () => (dispatch) => {
  dispatch({ type: 'ANAL_COST_INVENTORY_RESET' });
};